// extracted by mini-css-extract-plugin
export default {"frequentlyUsedPages":"styles_frequentlyUsedPages__qIzbh","linkContainer":"styles_linkContainer__QPuWQ","link":"styles_link__J-5eM","linkIcon":"styles_linkIcon__fpSVf"};